export default __webpack_public_path__ + "static/media/students-white.a360110d.svg";